import React from 'react'
import ReactOnRails from "react-on-rails/client";

import LanguageSelect from 'frontend/Navigation/LanguageSelect'
import PopularLocations from 'frontend/Navigation/PopularLocations'
import ContactForm from 'frontend/Navigation/ContactForm'
import Cookies from 'frontend/Navigation/Cookies'
import MobileMenu from 'frontend/Navigation/MobileMenu'

ReactOnRails.register({LanguageSelect, PopularLocations, ContactForm, Cookies, MobileMenu})